import z from 'zod';

export const DefectTicketSettings = z.object({
    multiLanguageEnabled: z.boolean(),
    preferredLanguage: z.string(),
});
export type DefectTicketSettings = z.infer<typeof DefectTicketSettings>;
